import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { ItemType } from './typings';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateRelationDetailsModalItem',
  props: {
    item: null,
    type: null
  },
  setup(__props: any) {

const props = __props as {
    item: ItemType;
    type: string;
};



const status = computed(() => {
    const statuses = {
        published: 'Published',
        active: 'Active',
        draft: 'Draft',
        default: ''
    };

    if (!props.item.src || props.item?.published === undefined) {
        return statuses.default;
    }

    if (props.item.src.includes('woo.customily') || props.item.src.includes('etsystatic.com')) {
        return props.item.active === 'true' ? statuses.active : statuses.draft;
    } else {
        return props.item.published === 'true' ? statuses.published : statuses.draft;
    }
});

const getBadgeType = (type: string): string => {
    const types: Record<string, string> = {
        option: 'Option set',
        variant: 'Variant',
        default: ''
    };

    return types[type] || types.default;
};

return { __sfc: true,props, status, getBadgeType }
}

})